<template>
  <div class="spo-logo" @click="toggleCollapse">
    <div class="logo" v-if="logo"></div>
    <span class="anticon"></span>
    <span style="padding-left: 10px" v-if="device !== 'mobile'">
      {{ title }}
    </span>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore, mapActions } from 'vuex'

  export default {
    name: 'VabLogo',
    setup() {
      const store = useStore()
      return {
        logo: computed(() => store.getters['settings/logo']),
        title: computed(() => store.getters['settings/title']),
        device: computed(() => store.getters['settings/device']),
        ...mapActions({ toggleCollapse: 'settings/toggleCollapse' }),
      }
    },
  }
</script>
<style lang="less" scoped>
  .spo-logo {
    display: flex;
    align-items: center;

    height: 32px;
    margin: 0 10px;
    overflow: hidden;
    overflow: hidden;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.4);
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    .logo {
      width: 22px;
      height: 22px;
      display: inline-block;
      background: url(~@/assets/project_title.png) no-repeat 0 0;
      background-size: cover;
    }
  }
  @media screen and (max-width: 720px) {
    .spo-header {
      font-size: 14px;
    }
    .spo-logo {
      height: 32px;
      margin: 0 10px;
      font-size: 15px;

      .logo {
        width: 22px;
        height: 22px;
      }
    }
  }
</style>
